import InvoicePage from "@/components/billing/InvoicePage.vue";
import SubscribePage from "@/components/billing/SubscribePage.vue";

const billingRoutes = [{
    path: '/subscribe',
    component: SubscribePage,
    meta: {
        requiresAuth: false, // Allow public access to view subscription options
        title: "Subscribe | Akademi Siber"
    },
},
{
    path: '/invoice/:id',
    component: InvoicePage,
    meta: {
        requiresAuth: true, // Require auth for viewing invoices
        title: "Invoice Detail | Akademi Siber"
    },
},
];

export default billingRoutes;